import ForwardRef from "../../../../../icons/dist/react/default/chevron.js";
import { jsx } from "react/jsx-runtime";
import { cn } from "@videojs/utils/style";
//#region src/internal/skins/default-video/components/menus/menu-chevron.tsx
/** @jsxImportSource react */
function MenuChevron({ back = false, className } = {}) {
	return /* @__PURE__ */ jsx(ForwardRef, { className: cn(back ? "media-menu-back-chevron" : "media-menu-forward-chevron", className) });
}
//#endregion
export { MenuChevron };

//# sourceMappingURL=menu-chevron.js.map